import axios from "axios";
import { IGetReportsPayload } from "../models/report.model";

export const getReport = async (payload: IGetReportsPayload) => {
  const res = await axios.get("/reports", { params: payload });
  return res;
};